import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";
import "./css/style.css";
import "typeface-roboto";

const THEME = createTheme({
	typography: {
		fontFamily: `"Lato", sans-serif`,
	},
	palette: {
		primary: {
			main: "#37475A",
		},
		secondary: {
			main: "#37394B",
		},
	},
	MuiDataGrid: {
		header: {
			backgroundColor: "green",
		},
	},
});
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
	<ThemeProvider theme={THEME}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</ThemeProvider>
);
